import moment from "moment";

import ParagraphWithBoldParts from "components/ParagraphWithBoldParts";

import "./Notice.scss";

import type { ErrorDetails } from "models/ui";

export interface NoticeProps {
  className?: string;
  notice: ErrorDetails;
}

export const Notice = ({ className, notice }: NoticeProps) => (
  <div className={`notice-block ${className}`}>
    <div>
      <div className="notice-caption">
        <ParagraphWithBoldParts content={notice.error ?? ""} />
      </div>
      <p className="notice-description">{notice.description}</p>
      <strong className="notice-time">{moment(notice.time).fromNow()}</strong>
    </div>
  </div>
);
